function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("circle", {
  cx: 552,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 506.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 324.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 275.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 256.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 256.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 250.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 240.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 232.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 228.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 208.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 202.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 196.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 196.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 195.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 178.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 176.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 176,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 174.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 168.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 168.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 159.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 159.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 156,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 147.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 138.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 136.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 135.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 135.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 133.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 128.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 126.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 123.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 121.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 121.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 118.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 116.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 116.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 109.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 107,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 105.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 105.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 103.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 103.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 99.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 96.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 96.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 95.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 95.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 95.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 95.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 93.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 91.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 90.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 90.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 90.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 89.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 87.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 86.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 86.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 84.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 83.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 81.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 80.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 78,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 76,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 75.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 73.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 73.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 72.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 71.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 70.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 70.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 69.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 65.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 64.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 60.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 60.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 56.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 55.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 55.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 55,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 54.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 54,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 53.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 53,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 52.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 51.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 51.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 49.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 49.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 49,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 48.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 47.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 45.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 44.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 44.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 44.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 43.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 41.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 41.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 40.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 40.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}));

var SvgCountryFigures05 = function SvgCountryFigures05(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 582 124",
    style: {
      backgroundColor: "#0d5b61"
    }
  }, props), _ref);
};

export default SvgCountryFigures05;